module.exports = __webpack_public_path__ + "static/media/Buy_Data.7e790931.svg";